export default "__VITE_ASSET__CJFwY_Qy__"